import { AthenaCore } from 'athena-core';

export const useAthena = () => {
  return AthenaCore;
};
